<template>
    <label class="CategoryFilterItemCheck" :class="{'is-disabled': data.count === 0, 'is-hidden': hidden && !data.checked }">
        <input type="checkbox" :name="data.name" :value="data.value" :checked="data.checked"
               @change="handleChange({ name: data.name, value: data.value })" class="CheckboxBase">
        <span :data-count="data.count !== null ? '(' + data.count + ')' : ''">{{ data.label }}</span>
    </label>
</template>

<script lang="ts">
import {defineComponent, ref, Ref} from "vue";
import { mapActions } from "vuex";

export default defineComponent({
    name: "FilterCheck",
    props: {
        data: {
            type: Object,
            required: true
        },
        hidden: {
            type: Boolean,
            default: false
        }
    },
    methods: mapActions({
        handleChange: 'CHANGE_PARAMETER'
    })
})
</script>